// Software / IT products costume v1 — for companies selling software
// products or IT services (Aumonline is the first customer: Kreta,
// Apoopika, Jigyasa). Engine stage KEYS never change; only labels do.

export const SOFTWARE_COSTUME = {
  costumeId: "software_v1",

  stages: [
    { key: "new", label: "New" },
    { key: "spoke", label: "Spoke to them" },
    { key: "visit_scheduled", label: "Demo scheduled" },
    { key: "visited", label: "Demo done" },
    { key: "sent_price", label: "Sent quote" },
    { key: "signed_up", label: "Subscribed" },
    { key: "lost", label: "Lost" },
  ],

  stageColors: {
    new: "bg-amber-100 text-amber-800 border-amber-200",
    spoke: "bg-orange-100 text-orange-800 border-orange-200",
    visit_scheduled: "bg-yellow-100 text-yellow-800 border-yellow-200",
    visited: "bg-emerald-100 text-emerald-800 border-emerald-200",
    sent_price: "bg-rose-100 text-rose-800 border-rose-200",
    signed_up: "bg-green-100 text-green-800 border-green-200",
    lost: "bg-zinc-200 text-zinc-700 border-zinc-300",
  },

  defaultSources: [
    "BNI",
    "Referral",
    "Phone call",
    "Website",
    "Social media",
    "Exhibition / event",
    "Cold outreach",
    "Others",
  ],

  lostReasons: [
    "Price too high",
    "Chose another software",
    "Missing a feature they needed",
    "Not ready / postponed",
    "Just exploring",
    "Stopped responding",
    "Other",
  ],

  enquiryTypes: [
    "Software product",
    "SaaS subscription",
    "IT service",
    "Custom development",
    "Other",
  ],

  waTemplates: [
    { name: "First contact", body: "Hi {{name}}, this is {{me}} from {{company}}. Thanks for your interest — happy to show you how it works. When is a good time for a quick chat?" },
    { name: "Demo invite", body: "Hi {{name}}, shall we set up a short demo? 20 minutes on a screen-share and you'll see exactly how it fits your business. Tell me a day that works." },
    { name: "Quote share", body: "Hi {{name}}, sharing the pricing as discussed: {{quote}}. Happy to walk you through it on a call." },
    { name: "Soft follow-up", body: "Hi {{name}}, just checking in — any thoughts after the demo?" },
    { name: "Polite drop", body: "Hi {{name}}, hope all's well. Closing this for now; whenever the timing is right, ping me." },
  ],

  companyInfo: { name: "", me: "", address: "" },

  vocab: {
    unit: "licence",
    units: "licences",
    location: "product",
    locations: "products",
    customer: "client",
  },

  copy: {
    appName: "Jigyasa",
    sectionTrend: "Enquiries vs subscriptions — last 6 months",
    sectionAttention: "Needs your attention",
    attentionAllClear: "All caught up — nothing is waiting on you.",
    attentionWaitingQuote: "waiting after quote",
    remarksTitle: "Remarks & history",
    remarkPlaceholder: "e.g. Wants a demo next week — call Monday",
    addRemarkButton: "Add",
    remarksEmpty: "No remarks yet — add one after each call so the story stays in one place.",
    settingsSourcesTitle: "Manage enquiry sources",
    settingsSourcesNote: "Each organisation sets up its own list of where enquiries come from. Removing a source never changes past enquiries — it only affects new ones.",
    pastEnquiryBannerLabel: "Returning lead",
    pastEnquiryBannerNote: "We've spoken before — don't start cold.",
    footprintBannerLabel: "Already with us",
    footprintInlineDismiss: "This is someone new — clear and start fresh",
  },

  buttonsOn: {
    liveStock: false,
    upcomingStock: false,
    customerFootprint: false,
    pastEnquiries: true,
    pricingAndOffers: false,
    activityHistory: false,
    renewalPipeline: false,
    locationCatalog: false,
    satisfaction: false,
    availability: false,
    compliance: false,
    communications: false,
  },
};
